
import { Col, Container, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import API from "../../../common/API"
import { useState } from "react"

const ImportFichados = (props) => {
    const { t } = useTranslation("global")
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [state, setState] = useState({
        file: null,
        type: "new",
    })
    const uploadFile = async (obj) => {
        try {
            let file = obj.target.files[0]
            console.log(file)
            // Ensure it's an image


            let bodyData = new FormData()
            bodyData.append("path", file)
            setIsLoading(true)
            const request = await API.postAction(`File/Upload?folder=supportDocuments`, bodyData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            if (request.data.status !== "ok") {
                alert(t("Error al cargar el archivo: ") + request.data.message)
                return
            }

            setState({
                ...state,
                file: request.data.response,
            })
        } catch (e: any) {
            console.error(e)
            alert(t("Error al cargar el archivo: ") + e.message)
        } finally {
            setIsLoading(false)
        }



    }
    const processImport = async () => {
        if (!state.file) {
            alert(t("Por favor, selecciona un archivo para importar."))
            return
        }
        let bodyData = `file=${state.file}&type=${state.type}&folder=supportDocuments`;
        try {
            const request = await API.getAction(`fichados/ImportExternal?${bodyData}`);
            if (request.data.success) {
                alert(t("Importación realizada con éxito."))
                props.toggle()
            } else {
                alert(t("Error al importar el archivo: ") + request.data.message)
            }
        } catch (e: any) {
            console.error(e)
            alert(t("Error al importar el archivo: ") + e.message)
        }
    }
    return (
        <Modal
            show={true}
            onHide={props.toggle}
            size={props.modalSize ? props.modalSize : "md"}
            className={props.cssClass + " modalRight"}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("Importar fichados")}


                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row className="mx-0">

                        <Col xs={12} className="mt-3">
                            <label>{t("Selecciona un archivo XLSX para importar.")}</label><br />
                            <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" className="form-control" onChange={(e) => uploadFile(e)} />
                            <input type="text" className={`form-control mt-2 ${state.file ? "" : "d-none"}`} value={state.file ? state.file : ""} readOnly />
                        </Col>
                        <Col xs={12} className="mt-3">
                            <label>{t("Tipo de importación")}</label><br />
                            <select className="form-control" value={state.type} onChange={(e) => setState({ ...state, type: e.target.value })}>
                                <option value="new">{t("Nuevo")}</option>
                                <option value="update">{t("Actualizar")}</option>
                            </select>
                        </Col>

                        <Col xs={12} className="mt-3">
                            <hr />
                        </Col>

                        <Col xs={12} className="text-left">
                            <p>{t("Aquí puedes importar los fichados desde un archivo XLSX.")}  </p>
                            <p>
                                <b className="text-uppercase">{t("Asegúrate de seguir el formato correcto para la importación.")}</b>
                            </p>
                        </Col>
                        <Col xs={12} >
                            {t("Puedes descargar una plantilla de ejemplo para guiarte en el formato correcto.")}
                            <br />
                            <a
                                target="_blank" rel="noreferrer"
                                href="https://api.dataworker.com.do/supportDocuments/DeportadosModelo.xlsx"
                                className="btn btn-secondary mt-4"
                                download
                            >
                                <i className="fas fa-download"></i> {t("Descargar plantilla")}
                            </a>
                            <ul className="mt-3">
                                <li className="text-danger">{t("Si vas a actualizar, se utilizará la columna A como identificador de registro.")}</li>

                                <li className="text-danger">{t("Si estas actualizando y son muchos registros el proceso puede tardar bastante")}</li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={processImport} disabled={isLoading}>
                    {isLoading ? t("Importando...") : t("Importar")}
                </button>
            </Modal.Footer>
        </Modal>
    )
}
export default ImportFichados